var modMySubscriptions = function(){
    var scope = ".js-mod-my-subscriptions";
    ui.ready(
        scope,
        function($mod){
        }
    );
}();